<template>
  <div class="epidemicPreventionRanking">
    <table width="100%" cellspacing="0" cellpadding="15px" class="epidemicTableHeader">
      <tbody>
        <tr align="left" class="header">
          <td style="font-weight: bold" :width="!tableStatus ? '20%' : '15%'">排名</td>
          <td style="font-weight: bold" :width="!tableStatus ? '25%' : '16%'">姓名</td>

          <td style="font-weight: bold" :width="!tableStatus ? '30%' : '25%'">所属{{ level === '3' ? '机构' : '区县' }}</td>
          <td style="font-weight: bold" :width="!tableStatus ? '25%' : '20%'">防疫数量</td>
          <td :width="!tableStatus ? '0%' : '24%'" v-if="tableStatus">操作</td>
        </tr>
      </tbody>
    </table>
    <div class="epidemicTableContent" v-if="rankList.length <= 5">
      <table width="100%" cellspacing="0" cellpadding="15px">
        <tbody>
          <tr align="left" class="row" v-for="(item, index) in rankList" :key="index">
            <td :width="!tableStatus ? '20%' : '15%'">{{ index + 1 }}</td>
            <td :width="!tableStatus ? '25%' : '16%'">{{ item.realName }}</td>
            <td :width="!tableStatus ? '30%' : '25%'">{{ item.orgName }}</td>
            <td :width="!tableStatus ? '25%' : '20%'">{{ item.amount }}</td>
            <td :width="!tableStatus ? '0%' : '24%'" v-if="tableStatus">
              <el-link type="primary" @click="getPeoplePath(item.deptId)">工作路径 ></el-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="epidemicTableContent" v-if="rankList.length > 5">
      <listScroll :speed="0.5" ref="listScrolls">
        <table width="100%" cellspacing="0" cellpadding="15px">
          <tbody>
            <tr align="left" class="row" v-for="(item, index) in rankList" :key="index">
              <td :width="!tableStatus ? '20%' : '15%'">{{ index + 1 }}</td>
              <td :width="!tableStatus ? '25%' : '16%'">{{ item.realName }}</td>
              <td :width="!tableStatus ? '30%' : '25%'">{{ item.orgName }}</td>
              <td :width="!tableStatus ? '25%' : '20%'">{{ item.amount }}</td>
              <td :width="!tableStatus ? '0%' : '24%'" v-if="tableStatus">
                <el-link type="primary" @click="getPeoplePath(item.deptId)">工作路径 ></el-link>
              </td>
            </tr>
          </tbody>
        </table>
      </listScroll>
    </div>
  </div>
</template>

<script>
import listScroll from './listScroll';
export default {
  props: {
    zizhouuserInfo: {},
    level: '',
    isShowBack: false,
    rankList: []
  },
  data() {
    return {};
  },
  computed: {
    tableStatus() {
      return this.level === '3' || this.isShowBack;
    }
  },
  components: {
    listScroll
  },
  mounted() {},
  methods: {
    initAnimation() {
      this.$nextTick(() => {
        this.$refs.listScrolls.toScroll();
      }, 500);
    },
    getPeoplePath(item) {
      this.$emit('peoplePathCallBack', item);
    }
  }
};
</script>


<style lang="scss" scoped>
.epidemicPreventionRanking {
  height: 100%;
}
.epidemicTableHeader {
  margin-top: 0.65vw;
  .header {
    background: rgba(29, 95, 209, 0.2);
    color: #1d5fd1;
    font-size: 0.75vw;
    height: 1.84vw;
    td {
      padding: 0 0.325vw;
    }
  }
}
.epidemicTableContent {
  height: calc(100% - 2.36vw);
  .listScrolls {
    height: 100%;
  }
  tr {
    background: rgba(29, 95, 209, 0.2);
    color: white;
    font-size: 0.75vw;
    height: 1.842vw;
    &:nth-child(2n-1) {
      background: transparent;
    }
    td {
      padding: 0 0.325vw;
    }
  }
  .el-link.el-link--primary {
    color: #2ddca4;
    font-size: 0.75vw;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/businessModule/epidemicPreventionRanking-yulin.vue